import { Tooltip as AntdTooltip } from 'antd';
import styled from 'styled-components';

const Tooltip = styled(AntdTooltip).attrs({
  overlayStyle: { maxWidth: 'unset' },
  overlayClassName: 'tooltip-overlay-green',
  overlayInnerStyle: {
    background: '#00ab6b',
    padding: '12px',
    maxWidth: 'unset',
    lineHeight: '16px',
    fontSize: '12px',
    fontWeight: 700,
  },
})``;

export default Tooltip;
